module.exports = __webpack_public_path__ + "static/media/gucci.d0cbed6f.jpg";